module.exports = __webpack_public_path__ + "static/media/oamk-logo.3b174ac6.jpg";